export default window.SportsData.$;



// WEBPACK FOOTER //
// ./src/aliases/jquery.js